import { FC } from "react";

import Stack from "@mui/material/Stack";

import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardButton } from "@/dashboard-design-system/DashboardButton";
import { DashboardSkeleton } from "@/dashboard-design-system/Skeleton";
import { DashboardTypography } from "@/dashboard-design-system/Typography";

interface EmailContentsLoadStateProps {
  hasError: boolean;
  onRetry: () => void;
}

export const EmailContentsLoadState: FC<EmailContentsLoadStateProps> = ({ hasError, onRetry }) => {
  const { t } = useTranslate();

  if (!hasError) {
    return <DashboardSkeleton variant="rounded" sx={(theme) => ({ height: theme.spacing(30) })} />;
  }

  return (
    <Stack gap={2} alignItems="flex-start">
      <DashboardTypography role="alert">{t("common", "unknownErrorRetryOrContactUs")}</DashboardTypography>
      <DashboardButton variant="outlined" onClick={onRetry}>
        {t("dashboard", "translation.modal.retry")}
      </DashboardButton>
    </Stack>
  );
};
